module.exports = __webpack_public_path__ + "media/styles/images/svg/move-white-567590f90a67e98bcf4aa38d7fdcf4a8.svg";